import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import persistState from 'redux-localstorage'

import rootReducer from '../reducers'

export const history = createHistory()

let store

export const getStore = () => store

const configureStore = preloadedState => {
  store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(thunk, routerMiddleware(history)),
      persistState(['auth'], { key: 'sansiri-defect-report-admin' }),
    )
  )
  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer)
    })
  }
  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js